import {
  CheckCircleIcon,
  InformationCircleIcon
} from '@heroicons/react/24/outline';
import { Badge } from 'lib/components/Badge';

type PublisherNetworkTagProps = {
  isExtendedNetwork: boolean;
  onClick: () => void;
};

export default function PublisherNetworkTag({
  isExtendedNetwork,
  onClick
}: PublisherNetworkTagProps) {
  return (
    <Badge key="network-tag" status={isExtendedNetwork ? 'warning' : 'info'}>
      <span className="flex items-center">
        {isExtendedNetwork ? 'Extended Network' : 'Partner'}
        <button
          className="ml-1"
          type="button"
          onClick={onClick}
          title="Learn more"
        >
          {isExtendedNetwork ? (
            <InformationCircleIcon className="h-4 w-4" />
          ) : (
            <CheckCircleIcon className="h-4 w-4" />
          )}
        </button>
      </span>
    </Badge>
  );
}
